export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const NEW_USER = 'NEW_USER';
export const CREATE_START = 'CREATE_START';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILURE = 'CREATE_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const DESTROY_START = 'DESTROY_START';
export const DESTROY_SUCCESS = 'DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'DESTROY_FAILURE';

export const UNLOCK_START = 'UNLOCK_START';
export const UNLOCK_SUCCESS = 'UNLOCK_SUCCESS';
export const UNLOCK_FAILURE = 'UNLOCK_FAILURE';

export const UPDATE_PASSWORD_START = 'UPDATE_PASSWORD_START';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';
export const PASSWORD_ERROR_RESET = 'PASSWORD_ERROR_RESET';

export const ACCESS_KEYS_START = 'ACCESS_KEYS_START';
export const ACCESS_KEYS_SUCCESS = 'ACCESS_KEYS_SUCCESS';
export const ACCESS_KEYS_FAILURE = 'ACCESS_KEYS_FAILURE';

export const CREATE_ACCESS_KEYS_START = 'CREATE_ACCESS_KEYS_START';
export const CREATE_ACCESS_KEYS_SUCCESS = 'CREATE_ACCESS_KEYS_SUCCESS';
export const CREATE_ACCESS_KEYS_FAILURE = 'CREATE_ACCESS_KEYS_FAILURE';

export const UPDATE_ACCESS_KEYS_START = 'UPDATE_ACCESS_KEYS_START';
export const UPDATE_ACCESS_KEYS_SUCCESS = 'UPDATE_ACCESS_KEYS_SUCCESS';
export const UPDATE_ACCESS_KEYS_FAILURE = 'UPDATE_ACCESS_KEYS_FAILURE';

export const DELETE_ACCESS_KEYS_START = 'DELETE_ACCESS_KEYS_START';
export const DELETE_ACCESS_KEYS_SUCCESS = 'DELETE_ACCESS_KEYS_SUCCESS';
export const DELETE_ACCESS_KEYS_FAILURE = 'DELETE_ACCESS_KEYS_FAILURE';

export const EXPIRE_START = 'EXPIRE_START';
export const EXPIRE_SUCCESS = 'EXPIRE_SUCCESS';
export const EXPIRE_FAILURE = 'EXPIRE_FAILURE';

export const MULTIFACTOR_AUTH_START = 'MULTIFACTOR_AUTH_START';
export const MULTIFACTOR_AUTH_SUCCESS = 'MULTIFACTOR_AUTH_SUCCESS';
export const MULTIFACTOR_AUTH_FAILURE = 'MULTIFACTOR_AUTH_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const SHOW_PERSONAL_SETTINGS_OUTPUT_START = 'SHOW_PERSONAL_SETTINGS_OUTPUT_START';
export const SHOW_PERSONAL_SETTINGS_OUTPUT_SUCCESS = 'SHOW_PERSONAL_SETTINGS_OUTPUT_SUCCESS';
export const SHOW_PERSONAL_SETTINGS_OUTPUT_FAILURE = 'SHOW_PERSONAL_SETTINGS_OUTPUT_FAILURE';

export const UPDATE_PERSONAL_SETTINGS_OUTPUT_START = 'UPDATE_PERSONAL_SETTINGS_OUTPUT_START';
export const UPDATE_PERSONAL_SETTINGS_OUTPUT_SUCCESS = 'UPDATE_PERSONAL_SETTINGS_OUTPUT_SUCCESS';
export const UPDATE_PERSONAL_SETTINGS_OUTPUT_FAILURE = 'UPDATE_PERSONAL_SETTINGS_OUTPUT_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
